import * as A from '@radix-ui/react-avatar';
import { cn } from '@/lib/cn';

const sizes = {
  xs: 'size-6 text-[10px]',
  sm: 'size-8 text-xs',
  md: 'size-10 text-sm',
  lg: 'size-14 text-lg',
};

export function Avatar({
  name,
  src,
  size = 'sm',
  className,
}: {
  name: string;
  src?: string | null;
  size?: keyof typeof sizes;
  className?: string;
}) {
  const initials = name
    .split(' ')
    .slice(0, 2)
    .map((p) => p.charAt(0))
    .join('')
    .toUpperCase();

  return (
    <A.Root
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full',
        sizes[size],
        className,
      )}
    >
      {src && <A.Image src={src} alt="" className="size-full object-cover" />}
      <A.Fallback className="flex size-full items-center justify-center bg-brand-soft font-medium text-brand-soft-fg">
        {initials}
      </A.Fallback>
    </A.Root>
  );
}
